import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import Done from '@/components/Done'
import NotFound from '@/components/NotFound'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'

/* eslint-disable */

Vue.use(VueRouter)

// Put Login routes last since they have URL paramaters
// Base Url is:
// https://site.com/{studentHash}/{classHash}
// eg
// https://site.com/111-22-33/55-asdf-99

const router = new VueRouter({
  mode: 'history',
  // beforeEach: function(to, from, next) {
  //   console.log(`router`)
  //   console.log(this)
  //   if(to.meta.requiresAuth) {
  //       if (this.isLoggedIn()) {  //authUser.access_token
  //         next();
  //       }
  //       else {
  //         next({ name: 'login' });
  //       }
  //   }
  //   next();
  // },
  // isLoggedIn:  () => {  // not used!!
  //   console.log(`router -  NEVER CALLED?`)
  //   console.log(`ls: ${localStorage.getItem('id_token')}`)
  //   return (localStorage.getItem('id_token') !== null);
  // },
  routes: [
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      props: true,
      meta: {
        title: 'Terms and Conditions | Viva Learning',
        requiresAuth: false
      },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      props: true,
      meta: {
        title: 'Privacy | Viva Learning',
        requiresAuth: false
      }
    },
    {
      path: '/done/:c',
      name: 'Done',
      component: Done,
      props: true,
      meta: {
        title: 'Free Offer | Viva Learning',
        requiresAuth: false
      },
    },
    {   // 2nd to last
      path: '/home/:c',
      name: 'Home',
      component: Home,
      props: true,
      meta: {
        title: 'Free Offer | Viva Learning',
        requiresAuth: false
      },
      alias: '/:c'
    },
    {  // 404 page - last
      path: '*',
      name: 'NotFound',
      component: NotFound,
      props: true,
      meta: {
        title: '404 | Viva Learning',
        requiresAuth: false
      },
      alias: '/404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(`router to`)
  console.log(to)
  if(to.meta.requiresAuth) {
    console.log(`router1a`)
    if (!isLoggedIn()) {
        // next({ name: 'Login' });
        // this.to('/login')
        next( {path: '/login', query: {rurl: to.fullPath}})
      }
      else {
        next();
      }
  }
  // console.log(`router1b`)
  next();

  function isLoggedIn() {   // internal function
    console.log(`isLoggedIn internal...`)
    // console.log(`ls: ${localStorage.getItem('id_token')}`)
    return (localStorage.getItem('id_token') && true);
  }
})

const DEFAULT_TITLE = 'DEFAULT VIVA TITLE'

// https://stackoverflow.com/questions/51639850/how-to-change-page-titles-when-using-vue-router
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
      document.title = to.meta.title || DEFAULT_TITLE;
  })
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js